module.exports = __webpack_public_path__ + "static/img/finishimg@2x.0105d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bench/finishimg@2x.png
// module id = W3OU
// module chunks = 1